import React, {Fragment, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import {useDispatch} from 'react-redux';
import {hasPermission, Permissions} from '../../../../store/reducers/user';
import MessageBox from '../../../../util/messageBox';
import {setSnackbar} from '../../../../store/reducers/globals';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import {PATIENT_AGE_TYPE} from '../../../../util/patientContextUtil';
import useOpenState from '../../../../hooks/useOpenState';
import InjuryCwilted from './InjuryCwiltedForm';

const InjuryForm = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    // Form data
    const [injury, setInjury] = useState();
    const selectedForm = props.selectedHistoryForm;

    // Open state
    const [isSaveConfirmOpen, openSaveConfirm, closeSaveConfirm] = useOpenState(false, true);
    const [closeConfirm, setCloseConfirm] = useState(false);

    // Pickers Validations
    const [pickerError, setPickerError] = useState(false);

    useEffect(() => {
        if (props.agyleDialogInsertButtons) {
            props.agyleDialogInsertButtons([
                <AgyleButton
                    variant="contained"
                    onClick={openSaveConfirm}
                    disabled={isButtonDisabled() || props.disableSave}
                >
                    {t('Submit')}
                </AgyleButton>,
            ]);
        }
        if (props.onSubmitFunction) {
            props.onSubmitFunction(submit);
        }
        if (props.onDisableSubmit) {
            props.onDisableSubmit(isButtonDisabled() || props.disableSave || !dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_EDIT_CEILTWD)));
        }
    }, [injury, props.disableSave]);

    const checkMandatory = () => {
        if (props.patientAgeType === PATIENT_AGE_TYPE.PAEDS) {
            return true;
        } else {
            const injurySet = injury[0].value;
            let haveValues = Object.keys(injurySet).some((key) => {
                if (key !== 'cwilted' && key !== 'date' && key !== 'by') {
                    return !!injurySet[key] && injurySet[key]?.length !== 0;
                } else return false;
            });

            if (haveValues && (!injurySet.injuryDate || !injurySet.injuryTime)) {
                dispatch(setSnackbar({type: 'warning', message: 'Not all mandatory fields have been filled out.'}));
                return false;
            }
            return true;
        }
    };

    const isValid = () => {
        if (pickerError) {
            dispatch(setSnackbar({type: 'warning', message: 'Invalid Date or Time.'}));
            return false;
        }
        return true;
    };

    const submit = () => {
        closeSaveConfirm();
        if (dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_EDIT_CEILTWD)) && !props.disableSave) {
            const valid = !_.isNil(injury) && checkMandatory() && isValid();
            if (valid) {
                if (props.onSave) props.onSave(injury);
                if (props.onChange) props.onChange(injury);
                if (props.onClose) props.onClose();
            } else {
                return valid;
            }
        }
    };

    const checkIfIsEmpty = () => {
        if (!_.isNil(injury))
            setCloseConfirm(true);
        else
            props.onClose();
    };

    const handleCloseConfirm = () => {
        setCloseConfirm(false);
        props.onClose();
    };

    const getIsInjury = () => {
        if (_.isUndefined(props.isInjury)) {
            const isInjury = props.patient.clerking?.chiefComplaint ? props.patient.clerking?.chiefComplaint?.flagInjury
                : props.patient?.triage?.chiefComplaint ? props.patient?.triage?.chiefComplaint?.flagInjury : null;
            return isInjury;
        }
        return props.isInjury;
    };

    const isButtonDisabled = () => {
        const isInjury = getIsInjury();

        // For Children
        if (props.patientAgeType === PATIENT_AGE_TYPE.PAEDS) {
            return isInjury == '1' ? (!injury?.[0]?.value?.injuryDate && !injury?.[0]?.value?.injuryTime) : (!injury?.[0]?.value?.cwilted?.incidentDate && !injury?.[0]?.value?.cwilted?.incidentTime);
        } else {
            return !injury?.[0]?.value?.injuryDate && !injury?.[0]?.value?.injuryTime;
        }
    };

    return (
        <>
            <InjuryCwilted
                patient={props.patient}
                save={setInjury}
                patientAgeType={props.patientAgeType}
                selectedForm={selectedForm}
                errorPicker={setPickerError}
                parentForm={props.parentForm}
                seeAndTreat={props.seeAndTreat}
                isInjury={getIsInjury()}
                histPresComplaint={props.histPresComplaint}
            />

            <MessageBox
                onClose={closeSaveConfirm}
                title={t('Confirmation')}
                message={t('Are you sure you want to submit?')}
                haveAccept={{yes: t('Submit'), no: t('Close')}}
                onAccept={submit}
                open={isSaveConfirmOpen}
            />

            <MessageBox
                onClose={() => {
                    setCloseConfirm(false);
                }}
                title={t('Confirmation')}
                message={t('Are you sure you want to close? All data will be lost.')}
                haveAccept={{yes: t('Yes'), no: t('No')}}
                onAccept={handleCloseConfirm}
                open={closeConfirm}
            />
        </>
    );
};

export default InjuryForm;